<docs>
    Due to rapidily changing events, this content is loaded from BCC dynamically.
    Attempts to retrieve content from BCC by ID. Learn More will also attempt to get content from BCC.

    Usage: <notice-representative-product notice-bcc-id="covid_representative_product_notice"/>
</docs>

<template>
  <bootstrap>
    <div class="representative-product-info" v-if="noticeData.body">
      <div
        class="representative-product-info__heading"
        v-html="noticeData.displayName"
      ></div>
      <p class="representative-product-info__p" v-html="noticeData.body"></p>
      <a href="#" @click="openModal()" class="system-link-fat"
        >Learn more
        <span class="fa fa-angle-right"></span>
      </a>
    </div>
  </bootstrap>
</template>

<script>
export default {
  name: "NoticeRepresentativeProduct",
  props: {
    noticeBccId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      noticeData: {
        loaded: false,
        displayName: "",
        body: "",
        keyValues: ""
      }
    };
  },
  methods: {
    getNoticeContent: function(id) {
      var data = _.get(heb, `data.message.${id}`, false)
      if(data){
        this.noticeData = data;
        this.noticeData.loaded = true;
      }
    },
    openModal(){
      if(this.$route){
        this.hupOpenModal({modalId: 'representative-product-modal', closeAction: 'back'})
      }else{
        this.$store.commit('profile/OPEN_MODAL', {
          id: 'representative-product-modal'
        })
      }
    }
  },
  mounted() {
    if(this.noticeBccId){
      this.getNoticeContent(this.noticeBccId);
    }
  }
};
</script>

<style scoped>
.representative-product-info {
  background: linear-gradient(0deg, rgba(252, 209, 49, 0.05), rgba(252, 209, 49, 0.05)), #FFFFFF;
  /* Pineapple (#FCD131) */
  border: 1px solid #FCD131;
  box-sizing: border-box;
  border-radius: 24px;
  text-align: center;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 14px;
  margin-bottom: 1rem;
}

.representative-product-info__heading {
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 4px;
}

.representative-product-info__p {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
}
</style>
